module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv6-cc59b033a4788365d881fc7e93447f21.jpg";